module.exports = __webpack_public_path__ + "media/images/iconUp__okGreen-2d7169927bb514e080c17e3b13a7f1fe.png";